var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticStyle:{"width":"100%","height":"96vh","border":"none","padding":"0","margin":"0"},attrs:{"src":_vm.content}})])}
var staticRenderFns = []

export { render, staticRenderFns }